import React from 'react';

import { Card, Box } from '@bcp-nextgen-dx-component-factory/design-system';
import { rem } from '@helpers';
import { avatarLogoBcp } from '@icons';

import { useAccountSelectedHelper } from './accountSelected.helper';

export const AccountSelected: React.FC = () => {
	const { resources, formatNumber, selectedAccount } = useAccountSelectedHelper();

	return (
		<Box styles={{ gap: rem(16) }}>
			<Card.AccountRow
				mode="simplified"
				account={{
					name: selectedAccount?.companyName || '',
				}}
				headerTitle={resources.enterprise}
				feedbackBar={{
					mode: 'custom',
					status: {
						default: {
							backgroundColor: '#5D92CD',
						},
						hover: {
							backgroundColor: '#2b588a',
						},
					},
				}}
			/>
			<Card.AccountRow
				mode="simplified"
				account={{
					name: selectedAccount?.account.name || '',
					number: formatNumber,
					avatar: {
						source: avatarLogoBcp,
					},
				}}
				headerTitle={resources.accountLinked}
				feedbackBar={{
					mode: 'primary',
				}}
			/>
		</Box>
	);
};
